import { s as o } from "./symbol-constructor-detection.js";
var s = o && !Symbol.sham && "symbol" == typeof Symbol.iterator;
export { s as u };